// @team BFA Acquisition
import flow from 'lodash/flow';
import { NextPage } from 'next';

import { getQuizPageInitialProps } from '..';
import Quiz from '../../../../../features/Quiz/pages/Quiz';
import { withApolloContext } from '../../../../../utils/apollo';
import { Coupon } from '../../../../../utils/getCouponConfig';

const QuizWrapper: NextPage<{
  baseUrl?: string;
  isBoxycharmSubdomain?: boolean;
  coupon?: Coupon;
}> = ({ baseUrl, isBoxycharmSubdomain, coupon }) => (
  <Quiz
    baseUrl={baseUrl}
    isBoxycharmSubdomain={isBoxycharmSubdomain}
    coupon={coupon}
  />
);

QuizWrapper.getInitialProps = getQuizPageInitialProps;

const Cmp = flow(withApolloContext({ ssr: true }))(QuizWrapper);

Cmp.displayName = 'Quiz/Take/Questions';

export default Cmp;
